import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const setHomepageContent = async (values) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/content/homepage",
    values,
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const setUserSubsite = async (userId, subsiteId) => {
  console.log("adding user", userId, " to subsite ", subsiteId);
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/subsite/adduser",
    {
      "userId": userId,
      "subsiteId": subsiteId
    },
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const updateSiteDown = async (siteDownText) => {
  var response = await axios
    .post(process.env.REACT_APP_API_URL + "/admin/subsite/siteDown",
      { "content": siteDownText }, { headers: AuthHeader.authHeader() });
  return response.data;
};

const getHomepageContent = async () => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/content/homepage", { headers: AuthHeader.authHeader() });
  console.log(response.data.data.homepage);
  return response.data.data;
};

const loadRetailSubsite = async (code) => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/subsite/" + code);
  return response.data;
};

const updateShipping = async (subsiteId, shippingData) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/subsite/shipping",
    {
      "shippingData": shippingData,
      "subsiteId": subsiteId
    },
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const getSubsiteShipping = async (details) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/subsite/shipping",
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const toggleSubsiteStatus = async (value) => {
  var val = value ? "on" : "off";
  var response = await axios.get(process.env.REACT_APP_API_URL + "/admin/subsite/" + val,
    { headers: AuthHeader.authHeader() });
  return response.data;
};

const getAllSubsites = async () => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/allsubsites",
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const addEditSubsite = async (subsite) => {
  console.log("SUBSITE", subsite);
  const data = new FormData();

  data.append('logo', subsite.uploadedImage[0]);
  data.append('subsitename', subsite.subsitename);
  data.append('code', subsite.code);
  data.append('poc', subsite.poc);
  data.append('paymenttype', subsite.paymenttype);
  data.append('id', subsite.id);

  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/subsite/addedit", data,
    {
      headers: {
        ...AuthHeader.authHeader(),
        'Content-Type': 'multipart/form-data'
      }
    });

  console.log("RESPONSE", response);
  return response.data;

};

const getSubsitePriceCalculation = async () => {
  var response = await axios.get(process.env.REACT_APP_API_URL + "/admin/subsite/pricecalculation", { headers: AuthHeader.authHeader() });
  return response.data;
};

const updateSubsitePriceCalculation = async (priceCalculation) => {
  var response = await axios.post(process.env.REACT_APP_API_URL + "/admin/subsite/pricecalculation", priceCalculation, { headers: AuthHeader.authHeader() });
  return response.data;
};

const setSubsite = async (subsite) => {
  var response = await axios.post(process.env.REACT_APP_API_URL + "/subsite/setsubsite", {subsiteId: subsite.id}, { headers: AuthHeader.authHeader() });
  return response.data;
};

const SubsiteService = {
  setHomepageContent,
  getHomepageContent,
  setUserSubsite,
  loadRetailSubsite,
  updateShipping,
  getSubsiteShipping,
  getAllSubsites,
  toggleSubsiteStatus,
  updateSiteDown,
  addEditSubsite,
  getSubsitePriceCalculation,
  updateSubsitePriceCalculation,
  setSubsite
};

export default SubsiteService;